export const EditorialStatement = () => (
  <section data-testid="editorial-statement" className="bg-[#EFE8D9] pt-6 pb-16 md:pt-8 md:pb-24">
    <div className="container-lr">
      <p className="mx-auto max-w-4xl text-center font-serif text-4xl font-semibold leading-[1.08] tracking-display text-legacy md:text-5xl lg:text-6xl">
        Most people were taught how to earn money. Very few were taught how to <span className="accent-word">build a financial system.</span>
      </p>
    </div>
  </section>
);
